import createAction, { createClearAction } from "../../app/createAction";
import {
    BONUSES_SET_ACTIVE_FAILURE,
    BONUSES_SET_ACTIVE_START,
    BONUSES_SET_ACTIVE_SUCCESS,
    BONUSES_SET_AVAILABLE,
    CHECK_BONUS_PROMOCODE_FAILURE,
    CHECK_BONUS_PROMOCODE_START,
    CHECK_BONUS_PROMOCODE_SUCCESS,
    CLEAR_BONUS_PROMOCODE,
    CLEAR_BONUSES,
    GET_NEW_LIFE_ACCOUNTS_FAILURE,
    GET_NEW_LIFE_ACCOUNTS_START,
    GET_NEW_LIFE_ACCOUNTS_SUCCESS,
    PROCESS_INIT_PROMOCODE_START,
    SET_ACTIVE_PROMOCODES_FAILURE,
    SET_ACTIVE_PROMOCODES_START,
    SET_ACTIVE_PROMOCODES_SUCCESS,
    SET_BONUS_PROMOCODE,
    SET_NEW_LIFE_RESPAWN_BANNER_OPENED,
    SET_NEW_LIFE_RESPAWN_FAILURE,
    SET_NEW_LIFE_RESPAWN_START,
    SET_NEW_LIFE_RESPAWN_SUCCESS,
    SET_USED_PROMOCODES_START,
    SET_WELCOME_APPLY_BONUS,
    SET_WELCOME_BANNER_OPENED,
} from "./bonusesConstants";
import {
    IBonusesActiveList,
    IBonusesAvailableList,
    ICheckBonusPromocodePayload,
    INewLifeAccounts,
    INewLifeRespawnError,
    IPromocodesList,
    ISetNewLifeRespawnSuccess,
    ISetRespawnBannerOpenedPayload
} from "./types/bonusesActions";

export const bonusesSetActiveListStart = (payload?: unknown) => createClearAction<typeof BONUSES_SET_ACTIVE_START>(BONUSES_SET_ACTIVE_START, payload);
export const bonusesSetActiveListSuccess = (payload?: IBonusesActiveList) => createAction<typeof BONUSES_SET_ACTIVE_SUCCESS, IBonusesActiveList | undefined>(BONUSES_SET_ACTIVE_SUCCESS, payload);
export const bonusesSetActiveListFailure = (payload?: unknown) => createClearAction<typeof BONUSES_SET_ACTIVE_FAILURE>(BONUSES_SET_ACTIVE_FAILURE, payload);

export const bonusesSetAvailableList = (payload?: IBonusesAvailableList) => createAction<typeof BONUSES_SET_AVAILABLE, IBonusesAvailableList | undefined>(BONUSES_SET_AVAILABLE, payload);

export const clearBonusesAction = (payload?: unknown) => createClearAction<typeof CLEAR_BONUSES>(CLEAR_BONUSES, payload);

export const setActivePromocodesAction = (payload: string) => createAction<typeof SET_ACTIVE_PROMOCODES_START, string>(SET_ACTIVE_PROMOCODES_START, payload);
export const setActivePromocodesSuccess = (payload: IPromocodesList) => createAction<typeof SET_ACTIVE_PROMOCODES_SUCCESS, IPromocodesList>(SET_ACTIVE_PROMOCODES_SUCCESS, payload);
export const setActivePromocodesFailure = (payload: string) => createAction<typeof SET_ACTIVE_PROMOCODES_FAILURE, string>(SET_ACTIVE_PROMOCODES_FAILURE, payload);

export const setUsedPromocodesAction = (payload: IPromocodesList) => createAction<typeof SET_USED_PROMOCODES_START, IPromocodesList>(SET_USED_PROMOCODES_START, payload);

export const checkBonusPromocodeAction = (payload: ICheckBonusPromocodePayload) => createAction<typeof CHECK_BONUS_PROMOCODE_START, ICheckBonusPromocodePayload>(CHECK_BONUS_PROMOCODE_START, payload);
export const checkBonusPromocodeSuccess = (payload: string) => createAction<typeof CHECK_BONUS_PROMOCODE_SUCCESS, string>(CHECK_BONUS_PROMOCODE_SUCCESS, payload);
export const checkBonusPromocodeFailure = (payload: string) => createAction<typeof CHECK_BONUS_PROMOCODE_FAILURE, string>(CHECK_BONUS_PROMOCODE_FAILURE, payload);

export const clearBonusPromocodeAction = () => createClearAction<typeof CLEAR_BONUS_PROMOCODE>(CLEAR_BONUS_PROMOCODE);
export const setBonusPromocodeAction = (payload: string) => createAction<typeof SET_BONUS_PROMOCODE, string>(SET_BONUS_PROMOCODE, payload);

export const setWelcomeApplyBonusAction = (payload: boolean) => createAction<typeof SET_WELCOME_APPLY_BONUS, boolean>(SET_WELCOME_APPLY_BONUS, payload);
export const setWelcomeBannerOpenedAction = (payload: boolean) => createAction<typeof SET_WELCOME_BANNER_OPENED, boolean>(SET_WELCOME_BANNER_OPENED, payload);

export const getNewLifeAccountsAction = (payload?: unknown) => createClearAction<typeof GET_NEW_LIFE_ACCOUNTS_START>(GET_NEW_LIFE_ACCOUNTS_START, payload);
export const getNewLifeAccountsSuccess = (payload: INewLifeAccounts) => createAction<typeof GET_NEW_LIFE_ACCOUNTS_SUCCESS, INewLifeAccounts>(GET_NEW_LIFE_ACCOUNTS_SUCCESS, payload);
export const getNewLifeAccountsFailure = (payload?: unknown) => createClearAction<typeof GET_NEW_LIFE_ACCOUNTS_FAILURE>(GET_NEW_LIFE_ACCOUNTS_FAILURE, payload);

export const setNewLifeRespawnAction = (payload?: unknown) => createClearAction<typeof SET_NEW_LIFE_RESPAWN_START>(SET_NEW_LIFE_RESPAWN_START, payload);
export const setNewLifeRespawnSuccess = (payload: ISetNewLifeRespawnSuccess) => createAction<typeof SET_NEW_LIFE_RESPAWN_SUCCESS, ISetNewLifeRespawnSuccess>(SET_NEW_LIFE_RESPAWN_SUCCESS, payload);
export const setNewLifeRespawnFailure = (payload: INewLifeRespawnError) => createAction<typeof SET_NEW_LIFE_RESPAWN_FAILURE, INewLifeRespawnError>(SET_NEW_LIFE_RESPAWN_FAILURE, payload);

export const setNewLifeRespawnBannerOpened = (payload: ISetRespawnBannerOpenedPayload) => createAction<typeof SET_NEW_LIFE_RESPAWN_BANNER_OPENED, ISetRespawnBannerOpenedPayload>(SET_NEW_LIFE_RESPAWN_BANNER_OPENED, payload);

export const processInitPromocodeAction = (payload: string) => createAction<typeof PROCESS_INIT_PROMOCODE_START, string>(PROCESS_INIT_PROMOCODE_START, payload);
